"use client"
import { Card, CardContent } from "@/components/shared/ui/card"
import "@/styles/auth.css"
import { Input } from "@/components/shared/ui/input"
import { Button } from "@/components/shared/ui/button"
import { useTranslations } from "next-intl"
import useAuthStore from "@/store/authStore"
import { useState } from "react"
import toast from "react-hot-toast"
import { useRouter } from "@/navigation"
import { setLocalStorage } from "@/lib/localStorage"

const EmailResetPassword = () => {

    const t = useTranslations("Auth.emailResetPassword")
    const { forgotPassword } = useAuthStore()

    const [email, setEmail] = useState("")

    const router = useRouter()

    const handleSend = async (e: any) => {
        e.preventDefault();

        const res = await forgotPassword(email)

        if (res && res.status === 200) {
            toast.success("OTP sent to your email")
        }
        // Persist the email so the verify page can show it even without user state
        setLocalStorage("verifyEmail", email)
        router.push("/auth/verify")

    }

    return (
        <div className='w-full verify-bg'>
            <div className='form-container'>
                <h1 className="font-bold text-xl">
                    {t("title")}
                </h1>

                <Card className="w-full max-w-md mx-auto">
                    <CardContent className="py-4">
                        <div className="space-y-10">
                            <div className="w-full text-sm text-[#333]">
                                {t("desc")}
                            </div>

                            <div className="space-y-2">
                                <label className="text-right block text-sm font-medium">
                                    {t("email")}
                                </label>
                                <Input
                                    type="email"
                                    placeholder={t("email")}
                                    className="text-right"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <Button onClick={handleSend} variant="sub_primary" className="w-full rounded-xl  md:p-7 text-wrap">
                                {t("send")}
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    )
}

export default EmailResetPassword

